import { getWorker } from '@/services/modules/WorkerService'
import type { PageContext } from 'vike/types'

export { data }

async function data(pageContext: PageContext): Promise<any> {
    const payload = {
        platform_code: pageContext.routeParams?.code
    }

    try {
        const response = await getWorker(payload)
        const worker = response.data
        let title = ""
        let description = ""

        if (worker.company_name) {
            title = worker.company_name
            if (worker.specialty) title += " - " + worker.specialty
            if (worker.address) title += " - " + worker.address.town
            title += " - Professionnel topela"
        }
        if (worker.company_name) {
            description = worker.company_name
            if (worker.specialty) description += ", spécialisé dans le domaine : " + worker.specialty
            if (worker.address) description += " à " + worker.address.town
            description += ". Tarifs compétitifs, interventions rapides, satisfaction garantie. Contactez ce pro certifié topela."
        }

        return {
            title: title,
            description: description,
            worker: worker,
        }
    } catch (_) {
        return {
            title: "Profil du Professionnel",
            description: "Découvrez le profil complet de ce professionnel qualifié. Prenez contact pour obtenir un devis personnalisé de votre projet.",
            worker: null
        }
    }
}